// This script adds scroll-based reveal animations to .reveal-card elements
export function setupRevealAnimations() {
  const revealCards = document.querySelectorAll('.reveal-card');
  const revealOnScroll = () => {
    revealCards.forEach(card => {
      const rect = card.getBoundingClientRect();
      if (rect.top < window.innerHeight - 60) {
        card.style.animationPlayState = 'running';
      }
    });
  };
  window.addEventListener('scroll', revealOnScroll);
  revealOnScroll();
}
